import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import { applyModelsThunk } from "../store/slices/fileSlice";

export const useDataReviewLogic = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const processResponse = useSelector((s) => s.file?.processResponse);
  const applying = useSelector((s) => s.file?.applying);
  const applyResponse = useSelector((s) => s.file?.applyResponse);

  const hasProcessResponse = processResponse?.columns?.length > 0 ||
    processResponse?.numeric_columns?.length > 0 ||
    processResponse?.all_columns?.length > 0;

  const onBack = () => navigate("/dashboard/data-entry");
  const onBackToDashboard = () => navigate("/dashboard");

  const onConfigure = async (payload) => {
    const fileName = processResponse?.file_name || processResponse?.fileName;
    if (!fileName) {
      message.error("No file_name available to apply models.");
      return;
    }

    try {
      const result = await dispatch(applyModelsThunk({ ...payload, file_name: fileName })).unwrap();
      message.success("Models applied successfully.");
      // console.log("apply result:", result);
    } catch (err) {
      console.error("apply failed:", err);
      message.error(err?.message || "Apply models failed");
    }
  };

  return {
    processResponse,
    applying,
    applyResponse,
    hasProcessResponse,
    onBack,
    onConfigure,
    onBackToDashboard
  };
};